import script from "./provinceContent.vue?vue&type=script&setup=true&lang=js"
export * from "./provinceContent.vue?vue&type=script&setup=true&lang=js"

import "./provinceContent.vue?vue&type=style&index=0&id=d5310dac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_2718be04d8000a82592499ba4d4d2cef/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5310dac"]])

export default __exports__